import { motion } from 'framer-motion'

interface Props {
  accentSoft?: string
}

const TESTIMONIAL_IMAGES = [
  {
    src: 'https://static.lumi.new/0f/0fa2a62f798b9ae804319dea6db150e3.webp',
    alt: 'Depoimento de Graziela sobre o áudio de meditação do Ciclo 1',
  },
  {
    src: 'https://static.lumi.new/9e/9ec256766a06fe1fba78568522f24ccb.webp',
    alt: 'Depoimento de Joene sobre o Mapa de Emoções e a meditação personalizada',
  },
  {
    src: 'https://static.lumi.new/7f/7f2d3509170b88629df40ddf928d4262.webp',
    alt: 'Depoimento de Zelina sobre a meditação e o mapa de cura',
  },
  {
    src: 'https://static.lumi.new/dd/dd44c9e31188c1387f70fcc97cb537e4.webp',
    alt: 'Depoimento de Clarice sobre clareza e energia após escutar a meditação',
  },
  {
    src: 'https://static.lumi.new/b4/b402699a28c3affb03ee40f39899684b.webp',
    alt: 'Depoimento de Edijania sobre a leitura do mapa e a meditação personalizada',
  },
  {
    src: 'https://static.lumi.new/7d/7de35beb55fedca3362ba735c31e977f.webp',
    alt: 'Depoimento de Maria Tereza sobre o mapa e a meditação do Protocolo de Liberação e Cocriação',
  },
]

function ProtocolWhatsappTestimonials({ accentSoft = '#C8923A' }: Props) {
  // Layout desktop: 3 linhas de 2 (2 + 2 + 2)
  const row1 = TESTIMONIAL_IMAGES.slice(0, 2)
  const row2 = TESTIMONIAL_IMAGES.slice(2, 4)
  const row3 = TESTIMONIAL_IMAGES.slice(4, 6)

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="my-8 md:my-10"
    >
      <div className="text-center mb-6 md:mb-8">
        <p
          className="text-[10px] tracking-[0.4em] uppercase font-body mb-3"
          style={{ color: accentSoft }}
        >
          Depoimentos reais
        </p>
        <h3
          className="font-display text-[var(--ink)]"
          style={{
            fontSize: 'clamp(1.35rem, 3vw, 1.75rem)',
            lineHeight: 1.35,
            fontWeight: 500,
          }}
        >
          O que estão dizendo sobre o{' '}
          <em className="italic font-light" style={{ color: accentSoft }}>
            Protocolo de Liberação e Cocriação
          </em>
        </h3>
        <div
          className="h-px w-20 mx-auto mt-5"
          style={{
            background: `linear-gradient(90deg, transparent, ${accentSoft}66, transparent)`,
          }}
        />
      </div>

      <div className="max-w-3xl mx-auto space-y-5 md:space-y-6">
        {/* Linha 1 — 2 prints */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {row1.map((img, i) => (
            <TestimonialCard key={i} img={img} index={i} />
          ))}
        </div>

        {/* Linha 2 — 2 prints */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {row2.map((img, i) => (
            <TestimonialCard key={i + 2} img={img} index={i + 2} />
          ))}
        </div>

        {/* Linha 3 — 2 prints */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {row3.map((img, i) => (
            <TestimonialCard key={i + 4} img={img} index={i + 4} />
          ))}
        </div>
      </div>
    </motion.div>
  )
}

interface CardProps {
  img: { src: string; alt: string }
  index: number
}

function TestimonialCard({ img, index }: CardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="overflow-hidden rounded-2xl"
      style={{
        background: 'rgba(255,255,255,0.02)',
        border: '1px solid rgba(255,255,255,0.06)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.28), 0 2px 6px rgba(0,0,0,0.18)',
      }}
    >
      <img
        src={img.src}
        alt={img.alt}
        loading="lazy"
        className="block w-full h-auto"
        style={{ display: 'block' }}
      />
    </motion.div>
  )
}

export default ProtocolWhatsappTestimonials
